import * as React from "react";
import { PageLayout } from "@presentation/shared/layout/PageLayout";
import { ProgramType } from "@presentation/pages/programs/types";
import { T } from "@config/lang";
import { useTheme } from "@presentation/theme/useTheme";
import { cx } from "@presentation/vendor/classnames";

type Props = {
  program: ProgramType;
  onBack(): void;
};

export function Program({ program, onBack }: Props) {
  const { header } = useTheme();

  const {
    // adl_bruto_price,
    // adl_neto_price,
    // chd_bruto_price,
    // chd_neto_price,
    description,
    // gallery,
    // id,
    image,
    name,
  } = program;

  return (
    <PageLayout>
      <div className="container mx-auto prose-lg py-4">
        <div>
          <span
            onClick={onBack}
            className={cx(
              header.menu.link,
              "cursor-pointer text-xl opacity-50"
            )}
          >
            &larr; {T.program.all_programs}
          </span>
        </div>
        <h2 className="text-2xl font-bold my-6">{name}</h2>
        <img alt={name} className="w-full" src={image.large} />
        <div dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </PageLayout>
  );
}
